var render = function render(_c,_vm){return _c('div',{class:{
        'loading-wrapper': true,
        'loading-wrapper--is-loading': _vm.props.loading,
        [`loading-wrapper--${_vm.props.bgColor}`]: _vm.props.bgColor,
    }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }